// Global hospital branding. The logo is served by the backend at
// `/api/branding/logo` so super_admins can hot-swap it via /branding-settings.
// The values below act as sensible defaults; the real values are also
// available via useBranding() (see @/context/BrandingContext).
export const LOGO_URL = `${process.env.REACT_APP_BACKEND_URL}/api/branding/logo`;
// Platform (software) identity — used on Login and the app sidebar.
// Hospital printouts (Rx / bill / discharge) still use the tenant logo above.
export const VYOMRA_LOGO_URL = "/vyomra-logo.png";
export const PLATFORM_NAME = "The Vyomra HOS";
export const HOSPITAL_NAME = "DIVINE HOSPITAL";
export const HOSPITAL_TAGLINE = "MULTI SPECIALITY HOSPITAL";
export const HOSPITAL_LOCATION = "JAMNAGAR · GUJARAT";
